module.exports = __webpack_public_path__ + "static/media/rocket.2a581e35.svg";